import React, { useState } from "react";
import {
  Row,
  Col,
  Layout,
  Divider,
  Button,
  Menu,
  Card,
  Typography
} from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined
} from "@ant-design/icons";
import { createGlobalStyle } from "styled-components";

import Dashboard_r from "./Dashboard_r";
import Dashboard_i from "./Dashboard_i";
import Dashboard_he from "./Dashboard_he";
import Dashboard_s from "./Dashboard_s";

const { Content, Sider } = Layout;
const { Title } = Typography;

const GlobalStyle = createGlobalStyle`
  body {
    background: #f5f7fa;
  }
`;

const Dashboard_index = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [page, setPage] = useState("1");

  const items = [
    { key: "1", icon: <PieChartOutlined />, label: "R Dashboard" },
    { key: "2", icon: <PieChartOutlined />, label: "I Dashboard" },
    { key: "3", icon: <PieChartOutlined />, label: "HE Dashboard" },
    { key: "4", icon: <PieChartOutlined />, label: "S Dashboard" }
  ];

  return (
    <>
      <GlobalStyle />

      <Layout style={{ minHeight: "100vh" }}>
        {/* Sidebar */}
        <Sider
          collapsible
          collapsed={collapsed}
          trigger={null}
          theme="light"
          style={{
            boxShadow: "2px 0 8px rgba(0,0,0,0.05)"
          }}
        >
          <div
            style={{
              padding: 16,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 16
            }}
          >
            {collapsed ? "D3" : "Dashboard 3"}
          </div>

          <Menu
            mode="inline"
            selectedKeys={[page]}
            items={items}
            onClick={e => setPage(e.key)}
          />
        </Sider>

        {/* Main Content */}
        <Layout>
          {/* Header */}
          <div
            style={{
              background: "#fff",
              padding: "0 24px",
              display: "flex",
              alignItems: "center",
              height: 64,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />

            <Title level={4} style={{ margin: "0 0 0 16px" }}>
              Dashboard Overview
            </Title>
          </div>

          {/* Content */}
          <Content style={{ padding: 24 }}>
            <Card
              bordered={false}
              style={{
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              {page === "1" && <Dashboard_r />}
              {page === "2" && <Dashboard_i />}
              {page === "3" && <Dashboard_he />}
              {page === "4" && <Dashboard_s />}
            </Card>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default Dashboard_index;
